module.exports = __webpack_public_path__ + "static/media/upload.87853913.svg";